import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import RhSwiperEditing from "./RhSwiperEditing";
import RhSwiperUI from "./RhSwiperUI";

export default class RhSwiper extends Plugin {
    static get requires() {
        return [ RhSwiperEditing, RhSwiperUI ];
    }
}
